import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../authProvider";

export default function EnforcePermissions({
  children,
  role,
}: {
  children: React.ReactNode;
  role: "client" | "admin";
}) {
  const { user } = useAuthStore();

  const canAccessAdmin = user?.isAdmin || user?.isManager || user?.isCopywriter;

  if (role === "client" && !user?.isClientRelated) {
    if (canAccessAdmin) {
      return <Navigate to="/" />;
    } else {
      return <Navigate to="/login" />;
    }
  } else if (role === "admin" && !canAccessAdmin) {
    if (user?.isClientRelated) {
      return <Navigate to="/" />;
    } else {
      return <Navigate to="/login" />;
    }
  }

  return children;
}
